function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5338 0C17.9038 0 23.0677 5.04983 23.0677 11.2791C23.0677 14.2189 21.9176 16.8959 20.0335 18.9035L23.739 22.5163C24.0864 22.8551 24.0871 23.4051 23.7407 23.7448C23.4257 24.0536 22.9323 24.0822 22.5842 23.8304L22.4845 23.7464L18.7352 20.0901C16.7618 21.6346 14.2581 22.5582 11.5338 22.5582C5.16388 22.5582 0 17.5084 0 11.2791C0 5.04983 5.16388 0 11.5338 0ZM11.5338 1.73729C6.14503 1.73729 1.77652 6.00931 1.77652 11.2791C1.77652 16.5489 6.14503 20.8209 11.5338 20.8209C16.9227 20.8209 21.2912 16.5489 21.2912 11.2791C21.2912 6.00931 16.9227 1.73729 11.5338 1.73729Z",
  fill: "#200E32"
});

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.409cf62e.svg";
export { ForwardRef as ReactComponent };